import { type Injector } from '@angular/core';
import { BaseWidget } from '@sds/widget-gridster';

export class IncomeWidget extends BaseWidget<{ plantId: string; title: string }> {
  static readonly id = 'income';
  static readonly publicFriendly = false;

  static factory(
    injector: Injector,
    metaLinkId: string,
    x: number,
    y: number,
    rows: number,
    cols: number,
    data: { plantId: string; title: string }
  ): IncomeWidget {
    return new IncomeWidget(injector, metaLinkId, x, y, rows, cols, data);
  }

  constructor(
    injector: Injector,
    metaLinkId: string,
    x: number,
    y: number,
    rows: number,
    cols: number,
    data: { plantId: string; title: string }
  ) {
    super(injector, IncomeWidget.id, IncomeWidget.publicFriendly, metaLinkId, x, y, rows, cols, data);
    this.resolveComponent(async () => {
      const module = await import('./income.component');
      return Object.values(module)[0];
    });
  }
}
